import React from 'react';
import moment from 'jalali-moment';

/*
    - components
*/
import ChatBoxHeaderComponent from '../components/help-desk/ChatBoxHeader';
import ChatListComponent from '../components/help-desk/ChatList';
import RequestActionComponent from '../components/help-desk/RequestAction';
import RequestManagerComponent from '../components/help-desk/RequestManager';
import ReserveListComponent from '../components/help-desk/ReserveList';
import SearchInputComponent from '../components/help-desk/SearchInput';
import StartChatComponent from '../components/help-desk/StartChat';
import TabListComponent from '../components/help-desk/TabList';

/*
    - ihoDesignSystem
*/
import { Box, Button } from '@iho-design-system/Loader';

/*
    - api
*/
import activeFinalizedReservesAPI from '../api/get/ActiveFinalizedReserves';
import activeRoomsAPI from '../api/get/ActiveRooms';
import airplanCompaniesAPI from '../api/get/AirplanCompanies';
import cancelTicketAPI from '../api/get/CancelTicket';
import earlyCheckInOutAPI from '../api/get/EarlyCheckInOut';
import finalizeCheckoutdReservesAPI from '../api/get/FinalizeCheckoutdReserves';
import hasFreeTransferAPI from '../api/get/HasFreeTransfer';
import hotelInfoAPI from '../api/get/HotelInfo';
import latestTicketAPI from '../api/get/LatestTicket';
import maxExtraPersonCountAPI from '../api/get/MaxExtraPersonCount';
import officialInvoiceLinkAPI from '../api/get/OfficialInvoiceLink';
import reserveRoomsAPI from '../api/get/ReserveRooms';
import trainLinesAPI from '../api/get/TrainLines';
import userProfileAPI from '../api/get/UserProfile';

import createTicketAPI from '../api/add/CreateTicket';

const HelpDesk = ({ toggleHelpDeskProps, manualChangeTab }) => {

    /*
        - default value
    */
    const [requestType, setRequestType] = React.useState('');
    const [sendRequestStatus, setSendRequestStatus] = React.useState(false);
    const [searchInputPlaceholder, setSearchInputPlaceholder] = React.useState('');
    const [searchInputSearchKey, setSearchInputSearchKey] = React.useState('');
    const [ticket, setTicket] = React.useState('');

    const [selectedService, setSelectedService] = React.useState('');
    const [selectedReserve, setSelectedReserve] = React.useState({});

    const [reservesResult, setReservesResult] = React.useState([]);
    const [reserveRoomsResult, setReserveRoomsResult] = React.useState([]);
    const [createTicketResut, setCreateTicketResult] = React.useState('');
    const [activeRoomsResult, setActiveRoomsResult] = React.useState([]);
    const [maxExtraPersonCountResult, setMaxExtraPersonCountResult] = React.useState([]);
    const [earlyCheckInOutResult, setEarlyCheckInOutResultResult] = React.useState([]);
    const [officialInvoiceLinkResult, setOfficialInvoiceLinkResult] = React.useState('');
    const [airplanCompaniesResult, setAirplanCompaniesResult] = React.useState([]);
    const [trainLinesResult, setTrainLinesResult] = React.useState([]);
    const [hotelInfoResult, setHotelInfoResult] = React.useState([]);
    const [hasFreeTransferResult, setHasFreeTransferResult] = React.useState('');
    const [latestTicketResult, setLatestTicketResult] = React.useState('');
    const [userProfileResult, setUserProfileResult] = React.useState('');

    const [modifyRoom, setModifyRoom] = React.useState('');
    const [modifyDate, setModifyDate] = React.useState('');
    const [extraPassenger, setExtraPassenger] = React.useState('');
    const [halfCharge, setHalfCharge] = React.useState('');
    const [hotelInfo, setHotelInfo] = React.useState('');
    const [modifyPassenger, setModifyPassenger] = React.useState('');
    const [transfer, setTransfer] = React.useState('');

    /*
        - getReserves
    */
    const getReserves = async (tabType) => {
        let activeFinalizedReserves = await activeFinalizedReservesAPI();
        if (activeFinalizedReserves.status === 200) {
            activeFinalizedReserves = activeFinalizedReserves.data;
        }
        let finalizeCheckoutdReserves = await finalizeCheckoutdReservesAPI();
        if (finalizeCheckoutdReserves.status === 200) {
            finalizeCheckoutdReserves = finalizeCheckoutdReserves.data;
        }
        if (tabType !== 'invoice') {
            setReservesResult(activeFinalizedReserves);
        } else {
            setReservesResult(finalizeCheckoutdReserves);
        }
    }

    /*
        -getActiveRooms
    */
    const getActiveRooms = async (hotelId) => {
        let result = [];
        let parameters = {};
        parameters.hotelId = hotelId;
        result = await activeRoomsAPI(parameters);
        if (result.status === 200) {
            setActiveRoomsResult(result.data);
        }
    }

    /*
        - getAirplanCompanies
    */
    const getAirplanCompanies = async () => {
        let result = [];
        result = await airplanCompaniesAPI();
        if (result.status === 200) {
            setAirplanCompaniesResult(result.data);
        }
    }

    /*
        - cancelTicket
    */
    const cancelTicket = async (ticketId) => {
        let parameters = {}
        parameters.ticketId = ticketId;
        await cancelTicketAPI(parameters);
        toggleTab('removeRequest');
    }

    /*
        - getEarlyCheckInOut
    */
    const getEarlyCheckInOut = async (hotelId) => {
        let result = [];
        let parameters = {};
        parameters.hotelId = hotelId;
        result = await earlyCheckInOutAPI(parameters);
        if (result.status === 200) {
            setEarlyCheckInOutResultResult(result.data);
        }
    }

    /*
        - getHasFreeTransferAPI
    */
    const getHasFreeTransfer = async (hotelId) => {
        let result = [];
        let parameters = {};
        parameters.hotelId = hotelId;
        result = await hasFreeTransferAPI(parameters);
        if (result.status === 200) {
            setHasFreeTransferResult(result.data);
        }
    }

    /*
        - hotelInfo
    */
    const getHotelInfo = async (section, hotelId) => {
        let result = [];
        let parameters = {};
        parameters.hotelId = hotelId;
        parameters.sections = [section[0] !== undefined ? section[0] : -1, section[1] !== undefined ? section[1] : -1, section[2] !== undefined ? section[2] : -1, section[3] !== undefined ? section[3] : -1, section[4] !== undefined ? section[4] : -1, section[5] !== undefined ? section[5] : -1];
        result = await hotelInfoAPI(parameters);
        if (result.status === 200) {
            setHotelInfoResult(result.data);
        }
    }

    /*
        - getlatestTicketAPI
    */
    const getLatestTicket = async (reserve, ActionTypeId) => {
        let result = [];
        let parameters = {};
        parameters.reserveId = reserve.nuRequest;
        parameters.ActionTypeId = ActionTypeId;
        result = await latestTicketAPI(parameters);
        if (result.status === 200 && result.data !== 'empty') {
            if (result.data.Status === 0) {
                setLatestTicketResult(result.data.Id);
            } else if (result.data.Status === 2) {
                setLatestTicketResult(result.data.Id);
            }
            return result.data.Status;
        }
    }

    /*
        - getMaxExtraPersonCount
    */
    const getMaxExtraPersonCount = async (hotelId) => {
        let result = [];
        let parameters = {};
        parameters.hotelId = hotelId;
        result = await maxExtraPersonCountAPI(parameters);
        if (result.status === 200) {
            setMaxExtraPersonCountResult(result.data);
        }
    }

    /*
        - getOfficialInvoiceLink
    */
    const getOfficialInvoiceLink = async (reserveId) => {
        let result = [];
        let parameters = {};
        parameters.reserveId = reserveId;
        result = await officialInvoiceLinkAPI(parameters);
        if (result.status === 200) {
            setOfficialInvoiceLinkResult(result.data);
        }
    }

    /*
        - getReserveRooms
    */
    const getReserveRooms = async (reserveId) => {
        let result = [];
        let parameters = {};
        parameters.reserveId = reserveId;
        result = await reserveRoomsAPI(parameters);
        if (result.status === 200) {
            setReserveRoomsResult(result.data);
        }
    }

    /*
        - getTrainLines
    */
    const getTrainLines = async () => {
        let result = [];
        result = await trainLinesAPI();
        if (result.status === 200) {
            setTrainLinesResult(result.data);
        }
    }

    /*
        - getUserProfile
    */
    const getUserProfile = async () => {
        let result = [];
        result = await userProfileAPI();
        if (result.status === 200) {
            setUserProfileResult(result.data);
        }
    }
    React.useEffect(() => {
        getUserProfile();
    }, []);

    /*
        - sendRequest
    */
    const sendRequest = async (tabType) => {
        let parameters = {
            TicketMessages: [],
            ChatHistory: ''
        }
        parameters.ChatHistory = `${selectedReserve.hotelName},از ${moment(selectedReserve.arrivalDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} تا ${moment(selectedReserve.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} ${moment(selectedReserve.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MMMM/DD').split('/')[1].replace('0', '')}`;
        if (tabType === 'modifyRoomFinished') {
            parameters.Title = 'درخواست تغییر یا حذف اتاق';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 0;
            let keys = Object.keys(modifyRoom);
            let idkWhyHelper = '';
            keys.forEach((obj, index) => {
                if (index !== keys.length - 1) {
                    idkWhyHelper += `${modifyRoom[obj]} | `;
                } else {
                    idkWhyHelper += `${modifyRoom[obj]}`;
                }
            });
            let idkWhy = {};
            idkWhy.Message = idkWhyHelper;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'cancelFinished') {
            parameters.Title = 'درخواست کنسل کردن رزرو';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 1;
            let idkWhy = {};
            idkWhy.Message = `رزرو مربوط به شماره ${selectedReserve.nuRequest} کنسل شود`;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'modifyDateFinished') {
            parameters.Title = 'درخواست تغییر تاریخ اقامت';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 2;
            let idkWhy = {};
            idkWhy.Message = `تاریخ اقامت برای کد رزرو ${selectedReserve.nuRequest} به تاریخ ورود ${modifyDate.checkInDate} و تاریخ خروج ${modifyDate.checkOutDate} تغییر کند`;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'extraPassengerFinished') {
            parameters.Title = 'درخواست افزودن نفر اضافه';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 3;
            let keys = Object.keys(extraPassenger);
            let idkWhyHelper = '';
            keys.forEach((obj, index) => {
                if (index !== keys.length - 1) {
                    idkWhyHelper += `${extraPassenger[obj]} | `;
                } else {
                    idkWhyHelper += `${extraPassenger[obj]}`;
                }
            });
            let idkWhy = {};
            idkWhy.Message = idkWhyHelper;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'halfChargeFinished') {
            parameters.Title = 'درخواست افزودن نیم شارژ';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 4;
            let keys = Object.keys(halfCharge);
            let idkWhyHelper = '';
            keys.forEach((obj, index) => {
                if (obj !== '') {
                    if (index !== keys.length - 1) {
                        idkWhyHelper += `${halfCharge[obj]} | `;
                    } else {
                        idkWhyHelper += `${halfCharge[obj]}`;
                    }
                }
            });
            let idkWhy = {};
            idkWhy.Message = idkWhyHelper;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'modifyPassengerFinished') {
            parameters.Title = 'درخواست تغییر اطلاعات مسافران';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 6;
            let keys = Object.keys(modifyPassenger);
            let idkWhyHelper = '';
            keys.forEach((obj, index) => {
                if (index !== keys.length - 1) {
                    idkWhyHelper += `${modifyPassenger[obj]} | `;
                } else {
                    idkWhyHelper += `${modifyPassenger[obj]}`;
                }
            });
            let idkWhy = {};
            idkWhy.Message = idkWhyHelper;
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'invoiceFinished') {
            parameters.Title = 'درخواست فاکتور رسمی';
            parameters.ReserveId = selectedReserve.reserveId;
            parameters.RequestKey = 8;
            let idkWhy = {};
            idkWhy.Message = 'لینک فاکتور رسمی برای مسافر ارسال گردید'
            parameters.TicketMessages.push(idkWhy);
        }
        if (tabType === 'transferFinished') {
            parameters.Title = 'درخواست ترنسفر';
            parameters.ReserveId = selectedReserve.nuRequest;
            parameters.RequestKey = 7;
            let idkWhy = {};
            if (transfer.transferType === 'فرودگاه') {
                idkWhy.Message = `ترنسفر فرودگاه برای شماره پرواز ${transfer.transferVoucher} شرکت هواپیمایی ${transfer.transferCompany} از مبدا ${transfer.transferOrigin} و ساعت پرواز ${transfer.transferTime}`;
            }
            if (transfer.transferType === 'راه‌آهن') {
                idkWhy.Message = `ترنسفر راه آهن برای شماره قطار ${transfer.transferVoucher} شرکت ریلی ${transfer.transferCompany} از مبدا ${transfer.transferOrigin} و ساعت رسیدن ${transfer.transferTime}`;
            }
            parameters.TicketMessages.push(idkWhy);
        }
        console.log(parameters)
        setTicket(parameters.TicketMessages[0].Message);
        let result = await createTicketAPI(parameters);
        if (result !== 'failed') {
            setCreateTicketResult(result);
        }
    }

    /*
        - toggleTab
    */
    const toggleTab = (tabType) => {

        if (tabType !== 'home' && tabType !== 'newRequest') {
            getReserves(tabType);
        } else {
            setReservesResult([]);
        }

        setRequestType('');
        setSearchInputPlaceholder('');
        setSearchInputSearchKey('');
        setSendRequestStatus(false);
        setTicket('');

        setSelectedService('');

        //home
        if (tabType === 'home') {
            setReservesResult([]);
            setReserveRoomsResult([]);
            setCreateTicketResult('');
            setActiveRoomsResult([]);
            setMaxExtraPersonCountResult([]);
            setEarlyCheckInOutResultResult([]);
            setOfficialInvoiceLinkResult('');
            setAirplanCompaniesResult([]);
            setTrainLinesResult([]);
            setHotelInfoResult([]);
            setHasFreeTransferResult('');
            setLatestTicketResult('');
            setUserProfileResult('')

            setModifyRoom({});
            setModifyDate({});
            setExtraPassenger({});
            setHalfCharge({});
            setHotelInfo({});
            setModifyPassenger({});
            setTransfer({});
        }
        //home

        //newRequest
        if (tabType === 'newRequest') {
            setRequestType('newRequest');
        }
        //newRequest

        //modifyRoom
        if (tabType === 'modifyRoom') {
            setRequestType('newRequest,modifyRoom,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'modifyRoomFinished') {
            setRequestType('newRequest,modifyRoom,reserveList,selectReserve,modifyRoomFinished');
            sendRequest(tabType);
        }
        //modifyRoom

        //cancel
        if (tabType === 'cancel') {
            setRequestType('newRequest,cancel,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'cancelFinished') {
            setRequestType('newRequest,cancel,reserveList,selectReserve,cancelFinished');
            sendRequest(tabType);
        }
        //cancel

        //modifyDate
        if (tabType === 'modifyDate') {
            setRequestType('newRequest,modifyDate,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'modifyDateFinished') {
            setRequestType('newRequest,modifyDate,reserveList,selectReserve,modifyDateFinished');
            sendRequest(tabType);
        }
        //modifyDate

        //extraPassenger
        if (tabType === 'extraPassenger') {
            setRequestType('newRequest,extraPassenger,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'extraPassengerFinished') {
            setRequestType('newRequest,extraPassenger,reserveList,selectReserve,extraPassengerFinished');
            sendRequest(tabType);
        }
        //extraPassenger

        //halfCharge
        if (tabType === 'halfCharge') {
            setRequestType('newRequest,halfCharge,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'halfChargeFinished') {
            setRequestType('newRequest,halfCharge,reserveList,selectReserve,halfChargeFinished');
            sendRequest(tabType);
        }
        //halfCharge

        //hotelInfo
        if (tabType === 'hotelInfo') {
            setRequestType('newRequest,hotelInfo,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'hotelInfoFinished') {
            getHotelInfo(hotelInfo, selectedReserve.hotelId)
            setRequestType('newRequest,hotelInfo,reserveList,selectReserve,hotelInfoFinished');
        }
        //hotelInfo

        //modifyPassenger
        if (tabType === 'modifyPassenger') {
            setRequestType('newRequest,modifyPassenger,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'modifyPassengerFinished') {
            setRequestType('newRequest,modifyPassenger,reserveList,selectReserve,modifyPassengerFinished');
            sendRequest(tabType);
        }
        //modifyPassenger

        //invoice
        if (tabType === 'invoice') {
            setRequestType('newRequest,invoice,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'invoiceFinished') {
            setRequestType('newRequest,invoice,reserveList,selectReserve,invoiceFinished');
            sendRequest(tabType);
        }
        //invoice

        //transfer
        if (tabType === 'transfer') {
            setRequestType('newRequest,transfer,reserveList');
            setSearchInputPlaceholder('کد پیگیری رزرو را وارد نمایید');
        }
        if (tabType === 'transferFinished') {
            setRequestType('newRequest,transfer,reserveList,selectReserve,transferFinished');
            sendRequest(tabType);
        }
        //transfer

        //removeRequest
        if (tabType === 'removeRequest') {
            setRequestType('newRequest,removeRequest,selectReserve,removeRequestFinished');
        }
        //removeRequest

    }

    /*
        - selectReserve
    */
    const selectReserve = async (reserve) => {

        setSelectedReserve(reserve);

        //modifyRoom
        if (requestType === 'newRequest,modifyRoom,reserveList') {
            let result = await getLatestTicket(reserve, 0);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,modifyRoom,reserveList,selectReserve');
                setSelectedService('modifyRoom');
                setSearchInputPlaceholder('');
                getReserveRooms(reserve.nuRequest);
                getActiveRooms(reserve.hotelId);
            }
        }
        //modifyRoom

        //cancel
        if (requestType === 'newRequest,cancel,reserveList') {
            let result = await getLatestTicket(reserve, 1);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,cancel,reserveList,selectReserve');
                setSelectedService('cancel');
                setSearchInputPlaceholder('');
            }
        }
        //cancel

        //modifyDate
        if (requestType === 'newRequest,modifyDate,reserveList') {
            let result = await getLatestTicket(reserve, 2);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,modifyDate,reserveList,selectReserve');
                setSelectedService('modifyDate');
                setSearchInputPlaceholder('');
            }
        }
        //modifyDate

        //extraPassenger
        if (requestType === 'newRequest,extraPassenger,reserveList') {
            let result = await getLatestTicket(reserve, 3);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,extraPassenger,reserveList,selectReserve');
                setSelectedService('extraPassenger');
                setSearchInputPlaceholder('');
                getReserveRooms(reserve.nuRequest);
                getMaxExtraPersonCount(reserve.hotelId);
            }
        }
        //extraPassenger

        //halfCharge
        if (requestType === 'newRequest,halfCharge,reserveList') {
            let result = await getLatestTicket(reserve, 4);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,halfCharge,reserveList,selectReserve');
                setSelectedService('halfCharge');
                setSearchInputPlaceholder('');
                getReserveRooms(reserve.nuRequest);
                getEarlyCheckInOut(reserve.nuRequest);
            }
        }
        //halfCharge

        //hotelInfo
        if (requestType === 'newRequest,hotelInfo,reserveList') {
            setRequestType('newRequest,hotelInfo,reserveList,selectReserve');
            setSelectedService('hotelInfo');
            setSearchInputPlaceholder('');
        }
        //hotelInfo

        //modifyPassenger
        if (requestType === 'newRequest,modifyPassenger,reserveList') {
            let result = await getLatestTicket(reserve, 6);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,modifyPassenger,reserveList,selectReserve');
                setSelectedService('modifyPassenger');
                setSearchInputPlaceholder('');
                getReserveRooms(reserve.nuRequest);
            }
        }
        //modifyPassenger

        //invoice
        if (requestType === 'newRequest,invoice,reserveList') {
            setRequestType('newRequest,invoice,reserveList,selectReserve');
            setSelectedService('invoice');
            setSearchInputPlaceholder('');
            getOfficialInvoiceLink(reserve.reserveId);
        }
        //invoice

        //transfer
        if (requestType === 'newRequest,transfer,reserveList') {
            let result = await getLatestTicket(reserve, 8);
            if (result === 0) {
                setSelectedService('awaiting');
                setSearchInputPlaceholder('');
            } else if (result === 2) {
                setSelectedService('pending');
                setSearchInputPlaceholder('');
            } else {
                setRequestType('newRequest,transfer,reserveList,selectReserve');
                setSelectedService('transfer');
                setSearchInputPlaceholder('');
                getAirplanCompanies();
                getTrainLines();
                getHasFreeTransfer(reserve.hotelId);
            }
        }
        //transfer

    }

    /*
        - toggleTabProps
    */
    const toggleTabProps = (tabType) => {
        toggleTab(tabType);
    }

    /*
        - selectReserveProps
    */
    const selectReserveProps = (selectReserveProps) => {
        selectReserve(selectReserveProps);
    }

    /*
        - searchKeyProps
    */
    const searchInputSearchKeyProps = (searchInputSearchKeyProps) => {
        setSearchInputSearchKey(searchInputSearchKeyProps);
    }

    /*
        - cancelTicketProps
    */
    const cancelTicketProps = () => {
        let parameters = {};
        parameters.ticketId = latestTicketResult;
        cancelTicket(latestTicketResult);
    }

    /*
        - sendRequestStatusProps
    */
    const sendRequestStatusProps = (props) => {
        setSendRequestStatus(props);
    }

    /*
        - modifyRoomProps
    */
    const modifyRoomProps = (props) => {
        setModifyRoom(props);
    }

    /*
        - modifyRoomProps
    */
    const modifyDateProps = (props) => {
        setModifyDate({
            checkInDate: props[0],
            checkOutDate: props[1]
        });
    }

    /*
        - extraPassengerProps
    */
    const extraPassengerProps = (props) => {
        setExtraPassenger(props);
    }

    /*
        - halfChargeProps
    */
    const halfChargeProps = (props) => {
        setHalfCharge(props);
    }

    /*
        - hotelInfoProps
    */
    const hotelInfoProps = (props) => {
        setHotelInfo(props);
    }

    /*
        - modifyPassengerProps
    */
    const modifyPassengerProps = (props) => {
        setModifyPassenger(props);
    }

    /*
        - transferProps
    */
    const transferProps = (props) => {
        setTransfer(props);
    }

    /*
        - manualChangeTab
    */
    React.useEffect(() => {
        toggleTab(manualChangeTab);
    }, [manualChangeTab]);

    return (

        <React.Fragment>

            {/* chatBoxBody */}
            <Box
                className={`rounded-lg position-fixed border-solid border-medium bottom-md right-md position-relative`}
                ms={{
                    width: '480px',
                    height: '580px',
                    backgroundColor: 'var(--white)',
                    boxShadow: 'var(--shadow-dark)',
                    zIndex: '999',
                    '@media(max-width:576px)': {
                        width: 'calc(100% - 1.5rem)'
                    },
                    animation: 'chatBoxAnimation 1s ease-in-out',
                    '@keyframes chatBoxAnimation': {
                        'from': {
                            bottom: '-100%'
                        },
                        'to': {
                            bottom: 'var(--sizing-md)'
                        }
                    }
                }}>

                {/* chatBoxHeader */}
                <ChatBoxHeaderComponent
                    requestType={requestType}
                    toggleHelpDeskProps={toggleHelpDeskProps}
                    toggleTabProps={toggleTabProps} />
                {/* chatBoxHeader */}

                <Box
                    className={`d-flex flex-wrap align-content-end p-md overflow-hidden`}
                    ms={{
                        height: '460px'
                    }}>

                    {/* conversation */}
                    <Box
                        ms={{
                            '@keyframes chatAnimation': {
                                'from': {
                                    opacity: '0',
                                    bottom: '-16px'
                                },
                                'to': {
                                    opacity: '1',
                                    bottom: '0'
                                }
                            }
                        }}>

                        {/* startChat */}
                        <StartChatComponent
                            userProfileResult={userProfileResult} />
                        {/* startChat */}

                        {requestType.split(',')[0] === 'newRequest' &&
                            <React.Fragment>

                                {/* ChatListComponent */}
                                <ChatListComponent
                                    reservesResult={reservesResult}
                                    createTicketResut={createTicketResut}
                                    officialInvoiceLinkResult={officialInvoiceLinkResult}
                                    hotelInfoResult={hotelInfoResult}
                                    requestType={requestType}
                                    selectedReserve={selectedReserve}
                                    selectedService={selectedService}
                                    ticket={ticket} />
                                {/* ChatListComponent */}

                            </React.Fragment>
                        }
                        {/* conversationBox */}

                    </Box>

                    {/* tabList */}
                    <TabListComponent
                        requestType={requestType}
                        toggleTabProps={toggleTabProps} />
                    {/* tabList */}

                    {/* reserveList */}
                    {requestType.split(',')[2] === 'reserveList' && requestType.split(',')[3] === undefined &&
                        <ReserveListComponent
                            reservesResult={reservesResult}
                            selectedService={selectedService}
                            searchInputSearchKey={searchInputSearchKey}
                            selectReserveProps={selectReserveProps} />
                    }
                    {/* reserveList */}

                    {/* RequestManager */}
                    <RequestManagerComponent
                        reserveRoomsResult={reserveRoomsResult}
                        activeRoomsResult={activeRoomsResult}
                        maxExtraPersonCountResult={maxExtraPersonCountResult}
                        earlyCheckInOutResult={earlyCheckInOutResult}
                        hasFreeTransferResult={hasFreeTransferResult}
                        airplanCompaniesResult={airplanCompaniesResult}
                        trainLinesResult={trainLinesResult}
                        requestType={requestType}
                        selectedReserve={selectedReserve}
                        selectedService={selectedService}
                        toggleTabProps={toggleTabProps}
                        sendRequestStatusProps={sendRequestStatusProps}
                        modifyRoomProps={modifyRoomProps}
                        modifyDateProps={modifyDateProps}
                        extraPassengerProps={extraPassengerProps}
                        halfChargeProps={halfChargeProps}
                        hotelInfoProps={hotelInfoProps}
                        modifyPassengerProps={modifyPassengerProps}
                        transferProps={transferProps} />
                    {/* RequestManager */}

                    {/* requestFinished */}
                    {(requestType.split(',')[4] === 'modifyRoomFinished' || requestType.split(',')[4] === 'cancelFinished' || requestType.split(',')[4] === 'modifyDateFinished' || requestType.split(',')[4] === 'extraPassengerFinished' || requestType.split(',')[4] === 'halfChargeFinished' || requestType.split(',')[4] === 'hotelInfoFinished' || requestType.split(',')[4] === 'modifyPassengerFinished' || requestType.split(',')[4] === 'transferFinished' || requestType.split(',')[3] === 'removeRequestFinished') &&
                        <Box
                            className={`w-100 my-xs mb-0 d-flex`}
                            ms={{
                                gap: 'var(--sizing-xs)'
                            }}>
                            <Button
                                onClick={() => toggleTab('home')}
                                className={`w-100`}
                                variant='filled'
                                color='primary'>
                                بازگشت به منوی اصلی
                            </Button>
                        </Box>
                    }
                    {/* requestFinished */}

                </Box>

                <Box
                    className={`w-100 p-md pt-0 position-absolute bottom-0`}>

                    {/* searchInput */}
                    {selectedService === '' &&
                        <SearchInputComponent
                            reservesResult={reservesResult}
                            toggleTabProps={toggleTabProps}
                            searchInputPlaceholder={searchInputPlaceholder}
                            searchInputSearchKeyProps={searchInputSearchKeyProps} />
                    }
                    {/* searchInput */}

                    {/* requestAction */}
                    <RequestActionComponent
                        selectedService={selectedService}
                        sendRequestStatus={sendRequestStatus}
                        toggleTabProps={toggleTabProps}
                        cancelTicketProps={cancelTicketProps} />
                    {/* requestAction */}

                </Box>

            </Box>
            {/* chatBoxBody */}

        </React.Fragment >

    );

}

export default HelpDesk;